var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDown({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.29289 8.03899C3.68342 7.64846 4.31658 7.64846 4.70711 8.03899L10 13.3319L15.2929 8.03899C15.6834 7.64846 16.3166 7.64846 16.7071 8.03899C17.0976 8.42951 17.0976 9.06268 16.7071 9.4532L10.7071 15.4532C10.3166 15.8437 9.68342 15.8437 9.29289 15.4532L3.29289 9.4532C2.90237 9.06268 2.90237 8.42951 3.29289 8.03899Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.113975695cfd19b35f681afdf39d9009.svg";
export { ForwardRef as ReactComponent };